(function () {
  const MODAL_SELECTOR = '[data-mp-size-guide-modal]';

  function loadModalImages(modal) {
    modal.querySelectorAll('img[data-mp-defer-src]').forEach((img) => {
      if (img.dataset.mpLoaded === 'true') return;

      const srcset = img.getAttribute('data-mp-defer-srcset');
      const src = img.dataset.mpDeferSrc;

      if (srcset) {
        img.srcset = srcset;
        img.removeAttribute('data-mp-defer-srcset');
      }

      if (src) {
        img.src = src;
        img.removeAttribute('data-mp-defer-src');
      }

      img.dataset.mpLoaded = 'true';
      img.classList.remove('mp-deferred-media');
    });
  }

  function loadModalVideo(video) {
    if (!video || video.dataset.mpLoaded === 'true') return;

    const src = video.dataset.mpDeferSrc;
    if (!src) return;

    video.src = src;
    video.removeAttribute('data-mp-defer-src');
    video.dataset.mpLoaded = 'true';
  }

  function bindSizeGuideModal(modal) {
    if (!modal || modal.dataset.mpSizeGuideBound === 'true') return;
    modal.dataset.mpSizeGuideBound = 'true';

    const video = modal.querySelector('video');

    modal.addEventListener('click', () => {
      if (modal.hasAttribute('open')) {
        modal.hide();
      }
    });

    const observer = new MutationObserver(() => {
      if (modal.hasAttribute('open')) {
        loadModalImages(modal);

        if (video) {
          loadModalVideo(video);
          video.currentTime = 0;
          video.play().catch(() => {});
        }

        return;
      }

      if (video) {
        video.pause();
      }
    });

    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init(root = document) {
    root.querySelectorAll(MODAL_SELECTOR).forEach(bindSizeGuideModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
